import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const navLinks = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'hypotheken',
    label: 'Hypotheken'
  }, {
    id: 'woonboten',
    label: 'Woonboten'
  }, {
    id: 'verzekeringen',
    label: 'Verzekeringen'
  }, {
    id: 'over-ons',
    label: 'Over ons'
  }, {
    id: 'kosten',
    label: 'Kosten'
  }, {
    id: 'contact',
    label: 'Contact'
  }];
  const handleNavClick = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    onNavigate(id);
    window.scrollTo(0, 0);
  };
  return <footer className="bg-navy text-white pt-12 md:pt-16 pb-24 md:pb-0" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-12" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12" data-id="element-39">
          {/* Column 1: Brand */}
          <div data-id="element-40">
            <div className="bg-white px-5 py-4 md:px-6 md:py-5 rounded-brand inline-block mb-6" data-id="element-41">
              <img src="https://cdn.magicpatterns.com/uploads/wwkRQsvFdLQeu28ZZ6FKqh/JDG_LOGO_NAV.png" alt="JDG Hypotheken | Verzekeringen" className="h-16 md:h-20 w-auto object-contain" data-id="element-42" />
            </div>
            <p className="text-gray-300 text-lg leading-relaxed max-w-sm" data-id="element-43">
              Persoonlijk financieel advies dat past bij jouw situatie.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-44">
            <h3 className="text-gold font-bold text-xl mb-6" data-id="element-45">Snel naar</h3>
            <ul className="space-y-3" data-id="element-46">
              {navLinks.map(link => <li key={link.id} data-id="element-47">
                  <a href={`#${link.id}`} onClick={e => handleNavClick(e, link.id)} className="text-gray-300 hover:text-gold transition-colors inline-block" data-id="element-48">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div data-id="element-49">
            <h3 className="text-gold font-bold text-xl mb-6" data-id="element-50">Contact</h3>
            <ul className="space-y-4" data-id="element-51">
              <li className="flex items-start" data-id="element-52">
                <MapPinIcon className="w-5 h-5 text-gold mr-3 mt-1 flex-shrink-0" data-id="element-53" />
                <a href="https://maps.google.com/?q=Sloterweg+228,+1171+CX+Badhoevedorp" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-54">
                  Sloterweg 228
                  <br data-id="element-55" />
                  1171 CX Badhoevedorp
                </a>
              </li>
              <li className="flex items-center" data-id="element-56">
                <PhoneIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-57" />
                <a href="tel:0232052161" className="text-gray-300 hover:text-white transition-colors" data-id="element-58">
                  023-205 2161
                </a>
              </li>
              <li className="flex items-center" data-id="element-59">
                <MailIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-60" />
                <a href="mailto:info@jdgadvies.nl" className="text-gray-300 hover:text-white transition-colors" data-id="element-61">
                  info@jdgadvies.nl
                </a>
              </li>
              <li className="flex items-start pt-2" data-id="element-62">
                <ClockIcon className="w-5 h-5 text-gold mr-3 mt-1 flex-shrink-0" data-id="element-63" />
                <span className="text-gray-300" data-id="element-64">
                  Ma-Vr: 09:00 – 17:30
                  <br data-id="element-65" />
                  Za: Op afspraak
                </span>
              </li>
            </ul>
          </div>

          {/* Column 4: Keurmerken */}
          <div data-id="element-66">
            <h3 className="text-gold font-bold text-xl mb-6" data-id="element-67">
              Keurmerken & Registraties
            </h3>
            <ul className="space-y-4" data-id="element-68">
              <li className="flex items-center gap-4 bg-white/10 p-4 rounded-xl border border-white/10" data-id="element-69">
                <div className="bg-white rounded-lg p-2 flex-shrink-0" data-id="element-70">
                  <img src="https://cdn.magicpatterns.com/uploads/hLrKue75gCT8qjkamHbfdK/JDG_Erkend_adviseur.png" alt="Erkend Financieel Adviseur" className="h-7 w-auto object-contain" data-id="element-71" />
                </div>
                <span className="text-white text-sm font-semibold leading-tight" data-id="element-72">
                  Erkend Financieel Adviseur
                </span>
              </li>
              <li className="flex items-center" data-id="element-73">
                <ShieldCheckIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-74" />
                <span className="text-gray-300" data-id="element-75">AFM-geregistreerd</span>
              </li>
              <li className="flex items-center" data-id="element-76">
                <ShieldCheckIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-77" />
                <span className="text-gray-300" data-id="element-78">Aangesloten bij Kifid</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Legal Strip */}
      <div className="bg-[#001f3f] py-6" data-id="element-79">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row justify-between items-center text-sm text-gray-400 gap-6" data-id="element-80">
          <div className="flex flex-col gap-1 text-center lg:text-left" data-id="element-81">
            <span data-id="element-82">
              &copy; {new Date().getFullYear()} JDG Hypotheken | Verzekeringen.
              Alle rechten voorbehouden.
            </span>
          </div>
          <div className="flex flex-col gap-4 items-center lg:items-end" data-id="element-83">
            <div className="flex flex-wrap justify-center lg:justify-end items-center gap-x-3 gap-y-2 text-xs" data-id="element-84">
              <span className="text-gray-500 font-semibold uppercase tracking-wider w-full text-center lg:w-auto lg:text-left mb-1 lg:mb-0" data-id="element-85">
                Vergelijkingskaarten:
              </span>
              <a href="https://drive.google.com/file/d/1b8FvwxU2Y9PF0TaqQzvJqaRWdo7bIagE/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-white transition-colors" data-id="element-86">
                <ShieldCheckIcon className="w-3.5 h-3.5 mr-1" data-id="element-87" />
                Vermogen
              </a>
              <span className="hidden md:inline text-gray-600" data-id="element-88">|</span>
              <a href="https://drive.google.com/file/d/1w8d3v2y09IYEr-81wYVKgw4tzT1S25aa/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-white transition-colors" data-id="element-89">
                <ShieldCheckIcon className="w-3.5 h-3.5 mr-1" data-id="element-90" />
                Hypotheek
              </a>
              <span className="hidden md:inline text-gray-600" data-id="element-91">|</span>
              <a href="https://drive.google.com/file/d/1r-5ZvxILzRhR3rJ4CvLP2HSxFJVqNjHv/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-white transition-colors" data-id="element-92">
                <ShieldCheckIcon className="w-3.5 h-3.5 mr-1" data-id="element-93" />
                Risico's
              </a>
            </div>
            <div className="flex flex-wrap justify-center lg:justify-end gap-x-4 gap-y-2" data-id="element-94">
              <a href="#" onClick={e => handleNavClick(e, 'kosten')} className="hover:text-white transition-colors" data-id="element-95">
                Kosten
              </a>
              <span className="hidden md:inline text-gray-600" data-id="element-96">|</span>
              <a href="#" onClick={e => handleNavClick(e, 'privacy')} className="hover:text-white transition-colors" data-id="element-97">
                Privacyverklaring
              </a>
              <span className="hidden md:inline text-gray-600" data-id="element-98">|</span>
              <a href="#" onClick={e => handleNavClick(e, 'klachten')} className="hover:text-white transition-colors" data-id="element-99">
                Klachtenprocedure
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Registrations Sub-bar */}
      <div className="bg-[#00152b] py-4" data-id="element-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-101">
          <p className="text-center text-[12px] leading-relaxed text-gray-500 tracking-wide" data-id="element-102">
            AFM-vergunning: 12051006 · Kifid-aansluitnummer: 300.019545 · KVK:
            42010917
          </p>
        </div>
      </div>
    </footer>;
}